@if (notRemovableSelectedUsers?.length) {
  <app-basic-user-selection-list
    [(users)]="notRemovableSelectedUsers"
    [rippleDisabled]="true"
    [showDescription]="false"
  ></app-basic-user-selection-list>
}

@if (selectedUsers?.length) {
  <app-basic-user-selection-list
    [(users)]="selectedUsers"
    [alwaysShowSelectedContent]="true"
    (user)="handleUser($event)"
    [rippleDisabled]="true"
    [showDescription]="false"
  >
    <ng-template appSelected>
      <app-deselect-icon></app-deselect-icon>
    </ng-template>
  </app-basic-user-selection-list>
}
